import { COUNTRIES_TRANSLATED } from 'ha/constants/countriesTranslated';
import getLanguageFromUrl from '../getLanguageFromUrl';

// Insert countries to country URL
// Examples:
// /Netherlands => /countries/Netherlands
// /nl/Nederlands => /nl/countries/Netherlands
// /nl/Nederlands/rooms-for-rent => /nl/countries/Netherlands/rooms-for-rent
const lastTrailingSlashRegExp = /\/(?!.*\/)/;

export default function formatCountryUrl(location: string, category?: string) {
  const currentLanguageCode = getLanguageFromUrl(location);
  const translatedCountriesWord = COUNTRIES_TRANSLATED[currentLanguageCode];

  return `${location.replace(
    lastTrailingSlashRegExp,
    `/${translatedCountriesWord}/`,
  )}${category ? `/${category}` : ''}`;
}
